export default __webpack_public_path__ + "14de61a0d34ae0866407d3406c11279a.svg";